import React from 'react';
import { SETTINGS_CARD_SHELL } from '../utils/settingsSectionStyles';

export function SettingsCard({
  title,
  description,
  leading,
  actions,
  children,
  className,
  descriptionClassName,
}: {
  title: string;
  description?: React.ReactNode;
  leading?: React.ReactNode;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  descriptionClassName?: string;
}) {
  const titleId = React.useId();
  return (
    <section
      className={className ? `${SETTINGS_CARD_SHELL} ${className}` : SETTINGS_CARD_SHELL}
      aria-labelledby={titleId}
    >
      <div className={`flex items-center justify-between gap-4 ${description ? 'mb-1' : 'mb-5'}`}>
        <div className="flex min-w-0 items-center gap-2">
          {leading}
          <h2 id={titleId} className="min-w-0 truncate text-base font-bold text-app-text">
            {title}
          </h2>
        </div>
        {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
      </div>
      {description ? (
        <p className={descriptionClassName ?? 'text-sm text-app-text-muted mb-5'}>{description}</p>
      ) : null}
      {children}
    </section>
  );
}
